type Props = Readonly<{
  children: React.ReactNode
}>

function ClueText({children}: Props): React.JSX.Element {
  return <span className="font-bold text-secondary-4">{children}</span>
}

export default ClueText
